import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {Menu, X, Search} from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Blog", path: "/blog" },
    { name: "Resources", path: "/resources" },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-[#0A0D12]/95 backdrop-blur-lg shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <span className="text-3xl font-bold bg-gradient-to-r from-[#00D4AA] to-[#FF6B35] bg-clip-text text-transparent group-hover:scale-105 transition-transform duration-300">
              Osrey
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-all duration-300 hover:text-[#00D4AA] ${
                  location.pathname === link.path
                    ? "text-[#00D4AA]"
                    : "text-[#F5F7FA]"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="p-2 hover:bg-[#1C2A35] rounded-lg transition-colors duration-300"
            >
              <Search className="w-5 h-5 text-[#F5F7FA]" />
            </button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-[#1C2A35] transition-colors duration-300"
          >
            {isOpen ? (
              <X className="w-6 h-6 text-[#F5F7FA]" />
            ) : (
              <Menu className="w-6 h-6 text-[#F5F7FA]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-[#1C2A35] border-t border-[#3A4E5F]">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block text-base font-medium transition-colors duration-300 hover:text-[#00D4AA] ${
                  location.pathname === link.path
                    ? "text-[#00D4AA]"
                    : "text-[#F5F7FA]"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Search Modal */}
      {searchOpen && (
        <div className="absolute top-full left-0 w-full bg-[#1C2A35] border-t border-[#3A4E5F] p-4">
          <div className="max-w-2xl mx-auto">
            <input
              type="text"
              placeholder="Search Osrey articles..."
              className="w-full px-4 py-3 bg-[#0A0D12] text-[#F5F7FA] rounded-lg border border-[#3A4E5F] focus:outline-none focus:border-[#00D4AA] transition-colors duration-300"
              autoFocus
            />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;